import {
    FormControl, Grid, InputLabel, MenuItem, Select, Typography, List,
    ListItem, IconButton, makeStyles,
    ListItemSecondaryAction,
    TextField,
    Button,
    ListItemText,
} from "@material-ui/core"
import React from "react"
import AddIcon from '@material-ui/icons/Add'
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    formControl: {
        display: "Grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(0, 300px))`
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 40
    }
}))

const ProviderRegisterContact = (props) => {
    const classes = useStyles()
    const [required, setRequired] = React.useState(false)
    const contactTypeList = [
        { type: "WHATSAPP", description: "WhatsApp" },
        { type: "MAIL", description: "Email" },
        { type: "CELLPHONE", description: "Celular" },
        { type: "PHONE", description: "Telefone" }
    ]
    const [contact, setContact] = React.useState({
        type: "",
        description: ""
    })

    const addContact = () => {
        if (contact.type === "" || contact.description === "") {
            setRequired(true)
            return false
        }

        let providerContact = props.provider.contactTypeList

        providerContact.push(contact)
        props.updateProvider({ ...props.provider, contactTypeList: providerContact })

        setContact({ type: "", description: "" })
        setRequired(false)
    }

    const deleteContact = (contact) => {
        const providerContact = props.provider.contactTypeList.filter((item) => item !== contact)
        props.updateProvider({ ...props.provider, contactTypeList: providerContact })
    }

    return (
        <div>
            <Grid container direction="row"
                justifyContent="center"
                spacing={2}
                alignItems="center"
            >
                <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        Dados de Contato
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="contact-select">Tipo</InputLabel>
                        <Select
                            labelId="contact-select"
                            error={required}
                            id="contact-select"
                            onChange={(event) => { setContact({ ...contact, type: event.target.value }) }}
                            value={contact.type}
                        >
                            {contactTypeList.map((contact) => (
                                <MenuItem value={contact.type}>{contact.description}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={10} md={6}>
                    <TextField
                        label="Descrição do Contato"
                        margin="normal"
                        id="contact"
                        error={required}
                        name="contact"
                        helperText={props.required.contact ? "Necessário informar ao menos um contato" : ""}
                        onChange={(event) => { setContact({ ...contact, description: event.target.value }) }}
                        variant="outlined"
                        value={contact.description}
                        fullWidth />
                </Grid>
                <Grid item xs={12} lg={1} md={1}>
                    <Button
                        type="click"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={addContact}
                        className={classes.submit}
                    >
                        <AddIcon />
                    </Button>
                </Grid>
            </Grid>
            <Grid container
                direction="column"
                justify="center"
                alignItems="space-between">
                <Grid item xs={12} lg={12} md={12}>
                    <List dense>
                        {
                            props.provider.contactTypeList.map((item) => (
                                <ListItem>
                                    <ListItemText
                                        primary={item.description}
                                        secondary={contactTypeList.filter(type => type.type === item.type)[0].description}
                                    />
                                    <ListItemSecondaryAction onClick={() => deleteContact(item)}>
                                        <IconButton edge="end" aria-label="delete">
                                            <DeleteIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            ))
                        }
                    </List>
                </Grid>
            </Grid>
        </div>
    )

}

export default ProviderRegisterContact